import * as React from "react";
const SvgLeafSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#00ED64"
      d="M9.485 2.56a25 25 0 0 1-1.197-1.552.026.026 0 0 0-.038 0c-.104.147-.61.855-1.197 1.552-5.044 6.433.794 10.773.794 10.773l.049.033c.043.67.152 1.634.152 1.634h.435s.11-.959.153-1.634l.049-.038c.005.005 5.843-4.335.8-10.768m-1.22 10.675s-.26-.223-.331-.337v-.011l.316-7.004c0-.022.032-.022.032 0l.316 7.004v.01c-.071.115-.332.338-.332.338"
    />
  </svg>
);
export default SvgLeafSvg;
